import React from 'react'

const NoMatchRoute = () => (
  <div className="block">
    <h1>Page Not Found</h1>
    <p>We couldn't find the page you were looking for.</p>
  </div>
)

export default NoMatchRoute
